import Icon from '../components/Icon.vue'

Icon.register({
  warehouse: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M504 352H136.4C132 352 128.4 355.6 128.4 360L128.3 408C128.3 412.4 131.9 416 136.3 416H504C508.4 416 512 412.4 512 408V360C512 355.6 508.4 352 504 352zM504 448H136.1C131.7 448 128.1 451.6 128.1 456L128 504C128 508.4 131.6 512 136 512H504C508.4 512 512 508.4 512 504V456C512 451.6 508.4 448 504 448zM504 256H136.6C132.2 256 128.6 259.6 128.6 264L128.5 312C128.5 316.4 132.1 320 136.5 320H504C508.4 320 512 316.4 512 312V264C512 259.6 508.4 256 504 256zM610.5 117L338.4 3.7A48.1-48.1 0 0 1 301.5 3.7L29.5 117C11.7 124.5 0 141.9 0 161.3V504C0 508.4 3.6 512 8 512H88C92.4 512 96 508.4 96 504V256C96 238.4 110.6 224 128.6 224H511.4C529.4 224 544 238.4 544 256V504C544 508.4 547.6 512 552 512H632C636.4 512 640 508.4 640 504V161.3C640 141.9 628.3 124.5 610.5 117z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/warehouse.js
// module id = IkFC
// module chunks = 144